export default [
  {
    id: 1,
    address: 'UY - Ruta 8, Kilómetro 17.500',
    complement: 'Zona Franca, Zonamerica\nEdificio Beta 4, Oficina 006',
    state: 'Montevideo, Uruguay',
    flag: 'uy',
  },
];
